<template>
  <main-container title="お問合せ一覧" class="support-list-container">
    <div slot="main-content">
      <fixed-header-table :fixed="supports != null">
        <tr slot="header">
          <th style="flex-grow: 0; justify-content: center;">お問合せID</th>
          <th style="flex-grow: 0;">カテゴリー</th>
          <th>件名</th>
          <th style="flex-grow: 0;">作成日時</th>
          <th style="flex-grow: 0;">ステータス</th>
        </tr>
        <tr v-for="support in supports">
          <td style="flex-grow: 0; justify-content: center;"><router-link :to="{name: 'support-detail', params: {supportId: support.supportId}}">{{support.supportId}}</router-link></td>
          <td style="flex-grow: 0;">{{support.categoryName}}</td>
          <td style="word-break: break-all;">{{support.subject}}</td>
          <td style="flex-grow: 0">{{support.createdAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD HH:mm')}}</td>
          <td style="flex-grow: 0">{{getStatusName(support.status)}}</td>
        </tr>
      </fixed-header-table>

      <support-create v-if="visibleSupportCreate" @close="visibleSupportCreate=false" @added="reload"></support-create>
    </div>

    <template slot="main-footer">
      <el-button class="large" type="primary" @click="onClickAdd">新規お問合せ</el-button>
      <div class="support">
        <p>メールでのお問い合わせ</p>
        <p>
          <span class="mail">support-skyfox@sxi.co.jp</span>
          <span>　サービス時間：平日 10:00～18:00</span>
        </p>
      </div>
    </template>
  </main-container>
</template>

<script>
import BaseView from '../base'
import SupportCreateCmp from '../../components/support/dialogs/create.vue'
import { SupportStatus } from '../../defines/support'
import WebApiClient from '../../api/web'

export default {
  name: 'SupportListView',
  mixins: [BaseView],
  components: {
    'support-create': SupportCreateCmp
  },
  data () {
    return {
      supports: null,
      visibleSupportCreate: false
    }
  },
  created () {
    WebApiClient.getSupports(this).then(response => {
      this.supports = response.data.result.supports
      this.$forceUpdate()
    })
  },
  methods: {
    getStatusName (status) {
      switch (status) {
          case SupportStatus.WAITING:
            return 'サポート受付待ち'
          case SupportStatus.PROCESSING:
            return 'サポート対応中'
          case SupportStatus.ANSWERED:
            return 'サポート回答済み'
          case SupportStatus.RESOLVED:
            return '解決済み'
          case SupportStatus.CANCELED:
            return 'キャンセル'
          default:
            return ''
      }
    },
    onClickAdd () {
      this.visibleSupportCreate = true
    }
  }
}
</script>

<style scoped>
  .support-list-container >>> .main-content {
    padding: 24px;
  }

  .support {
    font-size: 0.8rem;
    margin-left: 1rem;
  }

  .mail {
    font-size: 1rem;
    font-weight: bold;
    background: url(../../../static/img/mail.png) no-repeat left center;
    background-size: 26px 18px;
    padding: 0 0 0 40px;
    line-height: 1;
    margin: 0 0 16px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/support/list.vue